
import { ref } from 'vue';
import { external } from '../apis/external';
import { useAuthStore } from '../stores/auth';
import { storeToRefs } from 'pinia';

import Button from 'primevue/button';
import IftaLabel from 'primevue/iftalabel';
import InputText from 'primevue/inputtext';
import Message from 'primevue/message';
import { useToast } from 'primevue/usetoast';

export default {
	name: 'AutoPeerNameEn',
	components: {
		IftaLabel,
		InputText,
		Message,
		Button,
	},
	props: {
		close: {
			type: Function,
			default: () => {},
		},
		onSuccess: {
			type: Function,
			default: () => {},
		},
	},
	setup(props) {
		const auth = useAuthStore();
		auth.hydrate();
		const { profile } = storeToRefs(auth);

		const toast = useToast();

		const form = ref({
			firstNameEn: { value: profile.value?.firstNameEn ?? '', errorMsg: '', invalid: false },
			lastNameEn: { value: profile.value?.lastNameEn ?? '', errorMsg: '', invalid: false },
		});

		const submitBtn = ref({ disabled: false, loading: false });

		const validateNameEn = (): boolean => {
			let valid = true;
			const pattern = /^[a-zA-Z\s]+$/;

			form.value.firstNameEn.value = form.value.firstNameEn.value.trim();
			form.value.lastNameEn.value = form.value.lastNameEn.value.trim();

			for (const key of ['firstNameEn', 'lastNameEn'] as const) {
				const field = form.value[key];
				if (field.value === '') {
					field.errorMsg = 'กรุณากรอกข้อมูล';
					field.invalid = true;
					valid = false;
				} else if (!pattern.test(field.value)) {
					field.errorMsg = 'กรอกได้เฉพาะภาษาอังกฤษเท่านั้น';
					field.invalid = true;
					valid = false;
				} else {
					field.errorMsg = '';
					field.invalid = false;
				}
			}

			return valid;
		};

		const handleSubmit = async () => {
			if (!validateNameEn()) return;

			submitBtn.value.loading = true;

			try {
				const payload = {
					firstName: '',
					lastName: '',
					firstNameEN: form.value.firstNameEn.value,
					lastNameEN: form.value.lastNameEn.value,
					promptPayID: '',
				};

				const resp = await external.updateInformation(payload);

				if (resp.code === '8017') {
					alert(resp.message);
					await auth.logout();
					window.location.reload();
					return;
				}

				if (resp.code !== '0') throw new Error(resp.message);

				await auth.fetchData();
				auth.hydrate();

				toast.add({ severity: 'success', summary: 'สำเร็จ', detail: 'บันทึกชื่อภาษาอังกฤษสำเร็จ', life: 3000 });

				await props.close();
				await props.onSuccess();
			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			} finally {
				submitBtn.value.loading = false;
			}
		};

		return {
			form,
			submitBtn,
			handleSubmit,
		};
	},
};
